import useAxiosCall from './useAxiosCall';
import { useTranslation } from '../Context/TranslationContext';
import { decryptData, encryptData } from '../Utilities/CryptoUtility';
import { SecureStorage } from '../Utilities/StorageEncryption';
const useTranslations = () => {
    const { makeApiCall } = useAxiosCall();
    const { setTranslations } = useTranslation();

    const handleApiCallSuccess = (data) => {
        let decryptedData = decryptData(data.data);
        setTranslations(decryptedData.translations);
    };

    const handleApiCallError = (errorMessage) => {
        console.log(errorMessage);
    };

    const fetchTranslations = async () => {
        try {
            const requestData = {
                data: encryptData(JSON.stringify(
                    {
                        domain: SecureStorage.getItem('domain')
                    }
                ))
            };

            await makeApiCall({
                requestData,
                url: 'getTranslations',
                requestType: 'POST',
                onSuccess: handleApiCallSuccess,
                onError: handleApiCallError,
            });

        } catch (error) {
            console.error('Error fetching translations:', error);
        }
    };

    return { fetchTranslations };
};

export default useTranslations;
